import "./Impressum.css";
import {useNavigate} from "react-router-dom";
import {Button} from "@radix-ui/themes";

function Impressum() {

    const navigate = useNavigate();

    const onZurueckClick = () => {
        navigate('/');
    }

    const impressumContent = (
        <main aria-labelledby="heading-impressum">
            <h1 id="heading-impressum" className="content-container-header">Impressum</h1>
            <div className="impressum-content">
                <p>Diese Fachanwendung steht nur für einen geschlossenen Benutzerkreis zur Verfügung. Sie wird
                    betrieben vom:
                </p>
                <address>
                    <strong>Landesamt für Umwelt Rheinland-Pfalz</strong><br/>
                    Kaiser-Friedrich-Straße 7<br/>
                    55116 Mainz / Rhein
                </address>

                <p>
                    Telefon: 06131 - 6033 - 0<br/>
                    Fax: 06131 - 1432966<br/>
                    E-Mail: <a href="mailto:bis-bokat@lfu.rlp.de"
                               aria-label="E-Mail an bis-bokat@lfu.rlp.de senden">bis-bokat@lfu.rlp.de</a>
                </p>

                <section aria-labelledby="section-fotos">
                    <h2 id="section-fotos" className="section-header">Fotos</h2>
                    <p>Landesamt für Umwelt Rheinland-Pfalz</p>
                </section>

                <section aria-labelledby="section-inhalte-links">
                    <h2 id="section-inhalte-links" className="section-header">Inhalte und Links</h2>
                    <p>Das Landesamt für Umwelt Rheinland-Pfalz übernimmt keine Verantwortung für die Inhalte von
                        Websites, die über Links auf unseren Seiten erreicht werden können. Diese Links werden nur bei
                        der Erstaufnahme überprüft und bewertet. Eine kontinuierliche Kontrolle der Texte, Graphiken,
                        Tabellen und Bilder ist nicht möglich. Das Landesamt distanziert sich ausdrücklich von allen
                        Inhalten, die möglicherweise straf- und haftungsrechtlich relevant sind oder gegen die guten
                        Sitten verstoßen.</p>
                </section>
                <Button id="btn-zurueck-anmeldung" onClick={onZurueckClick} aria-label="Zurück zur Anmeldeseite">
                    Zurück zur Anmeldung
                </Button>
            </div>
        </main>
    );

    return (
        <div className="impressum-container white">
            {impressumContent}
        </div>
    );
}

export default Impressum;
